<template>
    <div class="AllOrder" style="" id="homeBox">
<!--        订单状态筛选部分-->
        <div class="title"  style="font-size: 14px">
            <span class="titlew" >订单状态</span>
            <el-select size="mini" clearable v-model="select" slot="prepend" placeholder="全部" class="titlew" style="color:black;width: 150px;">
                <el-option v-for="val in zhuangcode" :key="val.status" :label="val.vc_status" :value="val.status"></el-option>

            </el-select>
            <span class="titlew" >下单日期</span>
            <el-date-picker size="mini" style="width: 150px"
                    v-model="startTime"
                    type="date"
                    placeholder="20XX-XX-XX"
                    value-format="yyyy-MM-dd"
                    clearable
            >
            </el-date-picker>
            <span class="titlew" >至</span>
            <el-date-picker size="mini" style="width: 150px "
                    v-model="endTime"
                    type="date"
                    clearable
                    value-format="yyyy-MM-dd"
                    placeholder="20XX-XX-XX"
            >
            </el-date-picker>
            <span style="padding: 0 10px 0 15px">配送方式</span>
            <el-select size="mini" clearable v-model="select1" slot="prepend" placeholder="全部" style="color:black;padding: 0 10px 0 5px;width: 150px;">
                <el-option  v-for="val in peicode" :key="val.status" :label="val.code"  :value="val.status"></el-option>

            </el-select>
            <el-input  size="mini" clearable v-model="buy" placeholder="请输入订单编号/合同号/购买方" style="height: 39px;width: 200px;line-height: 39px"></el-input>
            <button size="mini" style="background-color: #eed671;font-weight: bold;color: black;width: 60px;height: 39px;text-align: center;border:0;margin-left: 15px"  @click="find()">搜索</button>
            <a href="#" style="color:#efd773;font-weight:bolder;font-size: 15px;margin-left: 15px" @click="reset">重置</a>
        </div>
        <!--        激活订单按钮的操作部分-->
        <div class="contentcaozuo">
            <span style="padding: 0 10px">操作</span>
            <el-button size="mini" type="primary" :plain="true"  @click="activate">激活订单</el-button>
<!--            <el-button type="primary" plain @click="delivery">延长发货时间</el-button>-->
            <el-button size="mini" type="primary" :plain="true" @click="tihuo">延长提货时间</el-button>
        </div>
<!--表格显示订单数据部分-->
        <div class="main">
            <el-table
                    :height="tableHeight"
                    stripe
                    highlight-current-row
                    :header-cell-class-name="cellClass"
                    @row-click="click "
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @select="selectValue"
                    :key="time"

            >
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>

                <el-table-column
                        prop="status"
                        label="订单状态"
                        width="100">
                    <template slot-scope="scope">
                        <span :class="scope.row.status">[{{scope.row.vc_status}}]</span>
                    </template>
                </el-table-column
>
<!--                <el-table-column-->

<!--                        label="订单编号"-->
<!--                        width="120"-->
<!--                        show-overflow-tooltip>-->
<!--                    <template slot-scope="scope"-->
<!--                             >{{ scope.row.code}}</template>-->
<!--                </el-table-column>-->
                <el-table-column


                        label="合同号"
                        show-overflow-tooltip>
                    <template slot-scope="scope"
                    ><span style="color:lightskyblue;">{{ scope.row.vc_code}}</span></template>
                </el-table-column>
                <el-table-column
                        prop="vc_gmgsname"
                        label="购买公司"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="vc_pzname"
                        label="商品"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="totalPrice"
                        label="合计金额"
                        show-overflow-tooltip
                        align="right"

                >
                    <template slot-scope="scope"
                    ><span>{{ scope.row.currencySign}}{{ fun(scope.row.totalPrice)}}</span></template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="waitPrice"
                        align="right"
                        label="待支付金额"
                        show-overflow-tooltip>
                    <template slot-scope="scope"
                    ><span style="color:lightskyblue;">{{ scope.row.currencySign}}{{ fun(scope.row.waitPrice)}}</span></template>
                </el-table-column>
                <el-table-column
                        label="配送方式"
                        width="90"
                        show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.isConsignShip=='HDDDA04'?'自提':'送货' }}</template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="vc_xsgsname"
                        label="销售公司"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="dt_time"
                        label="下单时间"
                        show-overflow-tooltip>
                </el-table-column>
            </el-table>
            <!--      页码-->
            <div class="block">
                <div class="pages">
                    <div class="choosepage flexother  fl">
                        <el-pagination
                                small
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="this.currentPage"
                                :page-size="this.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="this.totalNum">

                        </el-pagination>
                    </div>

                </div>
        </div>

    </div>


<!--弹框-->


        <el-dialog
                :close-on-click-modal="false"
                :title="'订单详情('+title+')'"
                :visible.sync="dialogVisible"
                width="77%"
                top="30px"
                height="800"
                v-if="dialogVisible"
        >
        <Dialog :add="add" :mid.sync="mid"></Dialog>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                title="激活订单"
                :visible.sync="centerDialogVisible"
                width="400px"
                v-if="centerDialogVisible"
                @open="open"
                >
            <activateDialog @close="close" @getOrderManagerList="getOrderManagerList"  :selectVal="selectVal"></activateDialog>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                title="延长发货时间"
                :visible.sync="deliveryDialogVisible"
                width="400px"

                v-if="deliveryDialogVisible"
                >
            <deliveryDialog  @close1="close1"></deliveryDialog>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                title="延长提货时间"
                :visible.sync="tihuoDialogVisible"
                width="400px"

                v-if="tihuoDialogVisible"
        >
            <ti-huo  @close2="close2" @getOrderManagerList="getOrderManagerList" :selectVal="selectVal"></ti-huo>
        </el-dialog>
<!--        未选中正确的-->

    </div>

</template>

<script>
    import * as API from  "./api";
    import $ from 'jquery';

    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import Dialog from "./component/dialog";
    import activateDialog from "./component/activateDialog";
    import deliveryDialog from "./component/deliveryDialog"
    import TiHuo from "./component/TiHuo"
    import {platurl} from "../../../utils/baseUrl";
    export default {
        name: 'AllOrder',

        components:{Dialog,activateDialog,deliveryDialog,TiHuo},
        data() {
            return {
                xinxi:'',
                tishi:false,
                time:0,
                tihuoDialogVisible:false,//延长提货时间对话框
                deliveryDialogVisible:false,//延长发货时间对话框
                centerDialogVisible:false,//激活订单对话框
                baseerp: "",
                title:"",
                isshow:false,
                sinDate:0,
                // fukuan:'',//付款时间
                peisong:'',//配送方式
                dialogVisible: false,// 对话框
                select1:'',//配送方式
                buy:'',
                startTime: '',//初始时间
                endTime: '',//结束时间
                input1: '',
                input2: '',
                input3: '',
                select: 5,//status
                create_date:'',
                tableData: [],
                multipleSelection: [],
                currentPage: 1,//默认显示第一页
                pageSize:10,//默认每页显示10条
                totalNum: 500, //总页数
                i_id:0,
                mid:'',
                count1:'',
                add:{},//一列数据
                selectVal:{},//选中的数据
                zhuangcode:[{
                    status:"5",
                    vc_status:"全部"
                },{
                    status:"34",
                    vc_status:"待付款"
                },{
                    status:"1",
                    vc_status:"待收货"
                },{
                    status:"-4",
                    vc_status:"订单关闭"
                },{
                    status:"2",
                    vc_status:"已完成"
                },{
                    status:"-1",
                    vc_status:"客户终止"
                },{
                    status:"-5",
                    vc_status:"无"
                }
                ],//状态码
                peicode:[{
                    status:"HDDDA04",
                    code:"自提"
                },{
                    status:"HDDDA03",
                    code:"送货"
                }
                    ],//配送码
                peistatus:'',
                bill_id:"",
                tihuoval:'',
                jihuoyuanyin:'',
                tableHeight:0
            }
        },
        created(){

        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.$nextTick(()=>{
                this.onResize();
            }),
            this.baseerp=baseerp;
            this.getOrderManagerList()
        },
        computed:{
            // diffColor(val){
            //     // return(val)=>{
            //     //     if(val=='待付款'){
            //     //         return {'color':'orange'}
            //     //     }else if(val=='待收获'||val=='待提货'||val=='备货中'){
            //     //         return {'color':'green'}
            //     //     }
            //     // }
            //     // var a='';
            //         // if(val=='待付款'){
            //         //    var a='<span style="color:#E89112">val</span>'
            //         // }else if(val=='待收获'||val=='待提货'||val=='备货中'){
            //         //     var a='<span style="color:#179a16">val</span>'
            //         // }
            //         // return a
            // }
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            heightAuto(){
                this.$nextTick(()=>{
                    this.tableHeight = window.innerHeight -  300

                })
            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                this.tableHeight=n.h-130
                // console.log(n)
                // $("#homeBox").width(n.w);
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            fun(val){
            return Number(val).toFixed(2)
            },
            selectValue(selection,row){
                this.selectVal=row
                this.bill_id = row.id;
                // 清除 所有勾选项
                this.$refs.multipleTable.clearSelection()
                // 当表格数据都没有被勾选的时候 就返回
                // 主要用于将当前勾选的表格状态清除
                if(selection.length == 0) return
                this.$refs.multipleTable.toggleRowSelection(row, true);

            },
            open(){
                return this.selectVal
            },
            //激活订单
            activate(){
                if(this.selectVal.status=='HTSOS06'){
                    this.centerDialogVisible=true
                }else{

                    this.$message.error('请选择订单状态为关闭的订单激活');
                }
            },
            //延长发货时间对话框
            delivery(){
                this.deliveryDialogVisible=true
            },
            //激活订单对话框关闭
            close(){
                this.centerDialogVisible=false
            },
            // queding(val){
            //     this.jihuoyuanyin=val
            //     this.centerDialogVisible=false
            //     this.jihuodingdan()
            //     this.getOrderManagerList()
            //
            // },
            //延长发货时间对话框关闭
            close1(){
                this.deliveryDialogVisible=false
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.getOrderManagerList()
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.currentPage = val;    //动态改变
                this.getOrderManagerList()
            },
            cellClass(row){
                if (row.columnIndex === 0) {
                    return 'disabledCheck'
                }
            },
            // //激活订单
            // async jihuodingdan(){
            //     let result = await this.getCurrentMenuId({path: this.$route.path});
            //     if (result.i_id !== "") {
            //         this.mid = result.i_id;
            //         sessionStorage.setItem('mids', result.i_id)
            //     } else {
            //         this.mid = sessionStorage.getItem('mids')
            //     };
            //
            //     let param={
            //         id:this.selectVal.id,
            //         token:sessionStorage.getItem("token"),
            //         version:"",
            //         app:"",
            //         i_uid:sessionStorage.getItem("userid"),
            //         reason:this.jihuoyuanyin,
            //         i_mid:this.mid
            //     };
            //     let res=await API.jihuoorder(param)
            //     if(res.code==1){
            //         // this.select=res.list.status;
            //         // this.select1=res.list.isConsignShip;
            //         console.log(res)
            //
            //     } else if (res.code == -2) {
            //         this.$router.push('/login')
            //         this.$message.error(res.message);
            //     }else{
            //         this.$message.error(res.message);
            //     };
            //
            // },
            close2(){
                this.tihuoDialogVisible=false
            },
            //提货
            tihuo(){
                //console.log(sessionStorage.getItem("token"))

                if(this.selectVal.status=='HTSOS07'||this.selectVal.status=='HTSOS08'){
                    this.tihuoDialogVisible=true
                }else{
                    this.$message.error('请选择申请自提和自提超期的订单');
                }

            },
            // //提货时间确认
            // th(val){
            //     this.tihuoval=val
            //     this.tihuoDialogVisible=false
            //     this.yanchangtihuo()
            //     this.getOrderManagerList()
            //
            // },
            // //延长提货时间
            // async yanchangtihuo(){
            //     let result = await this.getCurrentMenuId({path: this.$route.path});
            //     if (result.i_id !== "") {
            //         this.mid = result.i_id;
            //         sessionStorage.setItem('mids', result.i_id)
            //     } else {
            //         this.mid = sessionStorage.getItem('mids')
            //     };
            //
            //     let param={
            //         id:this.selectVal.id,
            //         token:sessionStorage.getItem("token"),
            //         version:"",
            //         app:"",
            //         i_uid:sessionStorage.getItem("userid"),
            //         reason:'',
            //         i_mid:this.mid,
            //         overduetime:this.tihuoval
            //     };
            //     let res=await API.yctihuoorder(param)
            //     if(res.code==1){
            //         // this.select=res.list.status;
            //         // this.select1=res.list.isConsignShip;
            //         console.log(res)
            //
            //     } else if (res.code == -2) {
            //         this.$router.push('/login')
            //         this.$message.error(res.message);
            //     }else{
            //         this.$message.error(res.message);
            //     };
            //
            // },

            // 获取订单信息
            async getOrderManagerList(val){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                let param={
                    isConsignShip:this.select1,
                    dt_startTime:this.startTime,
                    dt_endTime:this.endTime,
                    i_state:this.select,
                    search:this.buy,
                    page_count:this.pageSize,
                    page_size:this.currentPage,
                };
                let res=await API.getOrder(param)
                if(res.code==1){
                    this.tableData=res.data;
                    this.totalNum=res.count;
                    var spname = []
                    for(let i =0 ;i<res.data.length;i++){
                        let a=res.data[i]
                        let b=a.detaiList.map(item=>{
                            return item.vc_pzname
                        })
                        spname.push(b.toString())
                    }
                    for(let k in this.tableData){
                        this.tableData[k].vc_pzname = spname[k]
                    }
                    this.centerDialogVisible=false
                    this.tihuoDialogVisible=false

                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };

            },

            find(){
                this.getOrderManagerList();
                this.currentPage=1
            },
            reset(){
                this.select1='';
                this.startTime='';
                this.endTime='';
                this.select='';
                this.buy=''
            },

            click(row,column,event){
                this.add=row;
                this.title=row.vc_code;
                this.dialogVisible=true
            }
                }
    }
</script>
<style lang="scss" scoped>

.AllOrder{
    /deep/ .HTSOS04_01{
        color: rgb(57,179,74);
    }
    /deep/.HTSOS04_02{
    color: rgb(57,179,74);
}   /deep/.HTSOS04_03{
        color: rgb(57,179,74);
    }
    /deep/.HTSOS02{
        color: rgb(255,145,30);
    }
    /deep/.HTSOS09{
        color: rgb(102,102,102);
    }
    /deep/.HTSOS10{
        color: rgb(102,102,102);
    }
    /deep/.HTSOS06{
        color: rgb(102,102,102);
    }
    /deep/.HTSOS07{
        color: rgb(253,135,177);
    }
    /deep/.HTSOS05{
        color: rgb(69,169,243);
    }
    /deep/.HTSOS08{
        color: rgb(255,145,30);
    }

background-color: #ffffff;
height: 755px;
    .orderID{
        height: 400px;
        width: 90%;
        border: 1px solid #e0e0e0;

    }
    /deep/.el-dialog--center .el-dialog__header{
        display: flex;
        justify-content: center;

    }
    .title{
        display: flex;
        padding: 10px 10px;
        /*justify-content: center;*/
        align-items: center;
        vertical-align: center;
        .input-with-select .el-input-group__prepend {
            background-color: #fff;
        }
        .titlew{
            padding: 0 10px;
        }

    }
    .contentcaozuo{
        display: flex;
        padding: 10px 10px 0 10px;
        /*justify-content: center;*/
        align-items: center;
        vertical-align: center;
    }
    .main{
        /*display: flex;*/
        /*padding: 10px 10px;*/
        /*justify-content: center;*/
        align-items: center;
        vertical-align: center;

    }
    /deep/.el-table .disabledCheck .cell .el-checkbox__inner{
        display: none !important;
    }
    .flex {
        display: flex;
        flex-flow: wrap;
        justify-content: flex-start;
        align-items: center;
    }

    .flexother {
        display: flex;
        flex-flow: wrap;
        justify-content: flex-end;
        align-items: center;
    }

    .fl{
        float: right;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 28px;
            width: 46px;
            margin:12px 0 0 10px;
        }
    }

    .fr{
        float:right;
           }

    .cl{
        clear: both;
    }

    /*.mrt20{*/
    /*    margin-top: 20px;*/
    /*}*/
    .mrl20{
        margin-left: 20px;
        }
    .mrb20{
        margin-right: 20px;
    }
    .mrr20{
        margin-right: 20px;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        width:90%
    }





}
</style>
